import { plainToClass } from 'class-transformer';
import {
  API_EMPLOYEE_CONTACT_FIND_ALL,
  API_EMPLOYEE_CONTACT_FIND_ONE,
  API_EMPLOYEE_CONTACT_CREATE,
  API_EMPLOYEE_CONTACT_UPDATE,
  API_EMPLOYEE_CONTACT_DELETE
} from '../api.routes';
import { BaseApi } from './base.api';
import { FindAllResponse } from '../types';
import { EmployeeContactDto } from '../dto';

export class EmployeeContactApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<EmployeeContactDto>> {
    return this.httpClient
      .get(API_EMPLOYEE_CONTACT_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(EmployeeContactDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<EmployeeContactDto> {
    return this.httpClient
      .get(API_EMPLOYEE_CONTACT_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(EmployeeContactDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<EmployeeContactDto> {
    return this.httpClient
      .post(API_EMPLOYEE_CONTACT_CREATE, data)
      .then(({ data }) => {
        return plainToClass(EmployeeContactDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<EmployeeContactDto> {
    return this.httpClient
      .put(API_EMPLOYEE_CONTACT_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(EmployeeContactDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_EMPLOYEE_CONTACT_DELETE, {
      pathParams: { uuid }
    });
  }
}
